import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getPaymentMethods } from '../../services/firebase';

// Async thunk to fetch payment methods
export const fetchPaymentMethods = createAsyncThunk(
  'payment/fetchPaymentMethods',
  async (_, { rejectWithValue }) => {
    try {
      const paymentMethods = await getPaymentMethods();
      return paymentMethods;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const paymentSlice = createSlice({
  name: 'payment',
  initialState: {
    paymentMethods: [],
    selectedPaymentMethod: null,
    loading: false,
    error: null,
  },
  reducers: {
    setSelectedPaymentMethod: (state, action) => {
      state.selectedPaymentMethod = action.payload;
    },
    clearSelectedPaymentMethod: (state) => {
      state.selectedPaymentMethod = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPaymentMethods.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPaymentMethods.fulfilled, (state, action) => {
        state.loading = false;
        state.paymentMethods = action.payload;
        const activeMethods = action.payload.filter((method) => String(method.status || 'active').toLowerCase() === 'active');
        const selectedStillActive = activeMethods.some((method) => method.id === state.selectedPaymentMethod?.id);
        if (!selectedStillActive) {
          state.selectedPaymentMethod = activeMethods[0] || null;
        }
      })
      .addCase(fetchPaymentMethods.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setSelectedPaymentMethod, clearSelectedPaymentMethod } = paymentSlice.actions;
export default paymentSlice.reducer;
